<template>
  <div :class="$style.about">
    <!-- 导航区域 -->
    <nav :class="$style['about-nav']">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        :class="[
          $style['about-nav-item'],
          { [$style['about-nav-item-active']]: activeIndex === index },
        ]"
      >
        <!-- 对于有路由的项，使用NuxtLink在新窗口打开 -->
        <template v-if="item.route">
          <nuxt-link :to="item.route" target="_blank">
            {{ item.name }}
          </nuxt-link>
        </template>
        <!-- 对于无路由的项，显示文本 -->
        <span v-else @click="handleNavClick(index)">
          {{ item.name }}
        </span>
      </div>
    </nav>

    <div :class="$style['about-content']">
      <!-- 关于极致 -->
      <div
        v-if="activeIndex === 0"
        :key="'about'"
        :class="$style['about-section']"
      >
        <h2 :class="$style['about-section-title']">
          关于极致<span>ABOUT US</span>
        </h2>
        <div
          id="about-section-intro"
          :class="[
            $style['about-section-content'],
            $style['about-section-intro'],
          ]"
          v-html="landingAbout"
        />
      </div>

      <!-- 发展历程 -->
      <div
        v-else-if="activeIndex === 1"
        :key="'history'"
        :class="$style['about-section']"
      >
        <h2 :class="$style['about-section-title']">
          发展历程<span>MILESTONE</span>
        </h2>
        <div :class="$style['about-section-content']">
          <base-swiper
            ref="gallerySwiper"
            :data="landingTimeline"
            fade
            :autoplay="{ delay: 3000, disableOnInteraction: true }"
            :class="$style['timeline-gallery']"
            :slide-change="handleGallerySlideChange"
          >
            <template #default="{ el }">
              <div :class="$style['timeline-gallery-image']">
                <img :src="el.image" />
              </div>
              <div :class="$style['timeline-gallery-title']">
                {{ el.subtitle }}
              </div>
            </template>
          </base-swiper>
          <!-- 缩略图 -->
          <div :class="$style['timeline-thumbnail']">
            <div :class="$style['timeline-thumbnail-wrap']">
              <base-swiper
                ref="thumbnailSwiper"
                :data="timelineData"
                :slides-per-view="3"
                :centered-slides="true"
                :loop="false"
                :initial-slide="1"
                :allow-slide-prev="false"
                :class="$style['timeline-thumbnail-swiper']"
                :slide-change="handleThumbnailSlideChange"
              >
                <template #default="{ el, index }">
                  <!-- 对于有路由的项（更多详情），使用NuxtLink在新窗口打开 -->
                  <nuxt-link
                    v-if="el.route"
                    :to="el.route"
                    target="_blank"
                    :class="$style['timeline-thumbnail-item']"
                    rel="noopener"
                  >
                    <div :class="$style['timeline-thumbnail-image']">
                      <img :src="el.thumbnail" />
                    </div>
                    <div
                      :class="[
                        $style['timeline-thumbnail-title'],
                        $style['timeline-thumbnail-more'],
                      ]"
                    >
                      {{ el.title }}
                    </div>
                  </nuxt-link>
                  <!-- 对于普通时间线项，使用普通的div -->
                  <div
                    v-else
                    :class="$style['timeline-thumbnail-item']"
                    @click="handleThumbnailClick(el, index)"
                  >
                    <div :class="$style['timeline-thumbnail-image']">
                      <img :src="el.thumbnail" />
                    </div>
                    <div :class="$style['timeline-thumbnail-title']">
                      {{ el.title }}
                    </div>
                  </div>
                  <i :class="$style['timeline-thumbnail-line']"></i>
                </template>
              </base-swiper>
            </div>
            <button
              :disabled="disabledPrev"
              :class="[$style['btn-arrow'], $style['timeline-thumbnail-prev']]"
              @click="prevThumbnail"
            />
            <button
              :disabled="disabledNext"
              :class="[$style['btn-arrow'], $style['timeline-thumbnail-next']]"
              @click="nextThumbnail"
            />
          </div>
        </div>
      </div>
    </div>

    <landing-mask :class="$style['about-mask']" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseSwiper from '../BaseSwiper'
import LandingMask from '../LandingMask'

export default {
  name: 'LandingAbout',
  components: {
    BaseSwiper,
    LandingMask,
  },
  data() {
    return {
      activeIndex: 0,
      navItems: [
        { name: '关于极致', route: null },
        { name: '发展历程', route: null },
        { name: '极致荣誉', route: '/honor' },
        { name: '', route: '/about' },
      ],
      disabledPrev: true,
      disabledNext: false,
      // 当前所在屏幕索引（从1开始）
      currentSection: 1,
      // fullpage.js 实例引用
      fullpageInstance: null,
    }
  },
  computed: {
    ...mapGetters(['landingAbout', 'landingTimeline']),
    timelineData() {
      if (this.landingTimeline && this.landingTimeline.length) {
        return [
          {
            title: '更多详情',
            thumbnail: require('./images/timeline-more.png'),
            route: '/about',
          },
          ...this.landingTimeline,
          {
            title: '更多详情',
            thumbnail: require('./images/timeline-more.png'),
            route: '/about',
          },
        ]
      }
      return []
    },
  },
  watch: {
    // 监听 currentSection 变化
    currentSection() {
      // 延迟执行，确保 DOM 更新完成
      setTimeout(() => {
        const swiperInstance =
          this.$refs.gallerySwiper && this.$refs.gallerySwiper.mySwiper
        if (swiperInstance && swiperInstance.autoplay) {
          if (this.currentSection === 3 && this.activeIndex === 1) {
            // 进入当前页且在发展历程标签，启动轮播
            swiperInstance.autoplay.start()
          } else {
            // 离开当前页或不在发展历程标签，停止轮播
            swiperInstance.autoplay.stop()
          }
        }
      }, 100)
    },
    // 监听 activeIndex 变化（标签页切换）
    activeIndex() {
      // 延迟执行，确保 DOM 更新完成
      setTimeout(() => {
        const swiperInstance =
          this.$refs.gallerySwiper && this.$refs.gallerySwiper.mySwiper
        if (swiperInstance && swiperInstance.autoplay) {
          if (this.currentSection === 3 && this.activeIndex === 1) {
            // 在当前页且切换到发展历程标签，启动轮播
            swiperInstance.autoplay.start()
          } else {
            // 不在发展历程标签，停止轮播
            swiperInstance.autoplay.stop()
          }
        }
      }, 100)
    },
  },
  mounted() {
    this.updateCurrentSection()

    // 初始时如果不在当前页或不在发展历程标签则停止轮播
    if (this.currentSection !== 3 || this.activeIndex !== 1) {
      const swiperInstance =
        this.$refs.gallerySwiper && this.$refs.gallerySwiper.mySwiper
      if (swiperInstance && swiperInstance.autoplay) {
        swiperInstance.autoplay.stop()
      }
    }
  },
  methods: {
    handleNavClick(index) {
      this.activeIndex = index
    },
    // 处理主轮播图滑动事件
    handleGallerySlideChange(swiper) {
      const activeIndex = swiper.activeIndex

      // 开始位置时禁用上一个按钮
      this.disabledPrev = activeIndex === 0
      // 结束位置时禁用下一个按钮
      this.disabledNext = activeIndex === this.landingTimeline.length - 1

      // 同步缩略图
      if (this.$refs.thumbnailSwiper) {
        this.$refs.thumbnailSwiper.slideTo(activeIndex + 1)
      }
    },
    // 处理缩略图滑动事件
    handleThumbnailSlideChange(swiper) {
      const activeIndex = swiper.activeIndex

      // 禁止滑动到"更多详情"
      if (activeIndex === 1) {
        swiper.allowSlidePrev = false
        swiper.allowSlideNext = true
      } else if (activeIndex === this.landingTimeline.length) {
        swiper.allowSlidePrev = true
        swiper.allowSlideNext = false
      } else {
        swiper.allowSlidePrev = true
        swiper.allowSlideNext = true

        // 如果不小心滑动到第一个"更多详情"，则滑动回第一个项目
        if (activeIndex === 0) {
          swiper.slideTo(1, 0)
        }

        // 如果不小心滑动到最后一个"更多详情"，则滑动回最后一个项目
        if (activeIndex === this.landingTimeline.length + 1) {
          swiper.slideTo(this.landingTimeline.length, 0)
        }
      }

      // 同步主轮播图（减去"更多详情"的偏移量）
      if (this.$refs.gallerySwiper && activeIndex > 0) {
        this.$refs.gallerySwiper.slideTo(activeIndex - 1)
      }
    },
    // 处理缩略图点击事件
    handleThumbnailClick(el, index) {
      // 切换到对应的时间线项目
      if (this.$refs.thumbnailSwiper) {
        this.$refs.thumbnailSwiper.slideTo(index)
      }
      // 同步主轮播图
      if (this.$refs.gallerySwiper) {
        this.$refs.gallerySwiper.slideTo(index - 1)
      }
    },
    // 更新当前所在屏幕索引
    updateCurrentSection(sectionNumber = null) {
      if (sectionNumber !== null) {
        // 直接设置指定的屏幕索引
        this.currentSection = sectionNumber
      } else if (this.fullpageInstance) {
        // 从 fullpage.js 实例获取当前激活的屏幕索引
        const activeSection = this.fullpageInstance.getActiveSection()
        if (activeSection) {
          this.currentSection = activeSection.index + 1
        }
      }
    },
    // 设置 fullpage.js 实例引用（由父组件调用）
    setFullpageInstance(instance) {
      this.fullpageInstance = instance
    },
    // 上一个
    prevThumbnail() {
      if (this.$refs.thumbnailSwiper) {
        this.$refs.thumbnailSwiper.slidePrev()
      }
    },
    // 下一个
    nextThumbnail() {
      if (this.$refs.thumbnailSwiper) {
        this.$refs.thumbnailSwiper.slideNext()
      }
    },
  },
}
</script>

<style lang="less" module>
.about {
  .size(100%);

  position: relative;
  background: url(./images/bg.jpg) repeat;
  background-size: contain;
  color: @landing-text-color;

  &::before {
    .size(5.86rem, 5.38rem);

    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    background: url('./images/about-decorate.png') no-repeat;
    background-size: 100% 100%;
  }

  &-mask::after {
    .size(1.75rem,6.92rem);

    content: '';
    position: absolute;
    background: url('./images/about-decorate-title.png') no-repeat;
    background-size: 100% 100%;
  }

  // 导航样式
  &-nav {
    position: relative;
    z-index: 1;
    display: flex;
    transform: translateY(-0.3rem);

    &-item {
      cursor: pointer;
      border-radius: 0 0.1rem 0 0.1rem;

      > span,
      > a {
        .size(100%);

        display: flex;
        align-items: center;
        justify-content: center;
      }

      a {
        color: inherit;
        text-decoration: none;
      }

      &:hover {
        color: @landing-primary;
      }

      &-active {
        color: #fff;
        background: @landing-primary;

        &:hover {
          color: #fff;
        }
      }

      // 最后一个导航项样式
      &:last-child {
        background: url('./images/btn-arrow.png') no-repeat;
        background-size: 100% 200%;

        &:hover {
          background-position: 0 100%;
        }
      }
    }
  }

  &-content {
    transform: translateY(0.3rem);
  }

  // 内容区域样式
  &-section {
    animation: fadeInUp 0.6s ease;

    &-title {
      position: relative;
      display: flex;
      align-items: flex-end;
      gap: 0.14rem;
      font-weight: 700;
      border-bottom: 0.01rem solid #afafaf;

      span {
        font-weight: 400;
        color: #afafaf;
      }

      &::after {
        .size(4em, 0.05rem);

        content: '';
        position: absolute;
        bottom: -0.03rem;
        left: 0;
        background-color: #ff1325;
      }
    }

    &-content {
      line-height: 1.8;
    }
  }

  // 时间线样式
  .timeline {
    &-gallery {
      &-image {
        height: 6.09rem;
        img {
          .size(100%);

          object-fit: contain;
        }
      }

      &-title {
        margin-top: 0.2rem;
        text-align: center;
        font-weight: 700;
      }
    }

    &-thumbnail {
      position: relative;

      &-wrap {
        position: relative;
        width: 7rem;
        margin: 0 auto;
        overflow: hidden;
      }

      &-prev,
      &-next {
        position: absolute;
        top: 0.45rem;
        left: 50%;
      }

      &-prev {
        transform: rotateY(-180deg) translateX(3.8rem + 0.81);
      }

      &-next {
        transform: translateX(3.8rem);
      }

      &-swiper {
        width: 9rem;
        margin-top: 0.2rem;
      }

      &-item {
        display: block;
        width: 1.01rem;
        text-align: center;
        cursor: pointer;

        &::after {
          .size(1.8rem, 0.02rem);

          content: '';
          position: absolute;
          top: 0.52rem;
          right: 0.18rem;
          background-color: #5f5e5e;
        }
      }

      &-image {
        .size(100%, 0.93rem);

        position: relative;

        img {
          .size(0.78rem);

          z-index: 1;
          position: absolute;
          top: 0.1rem;
          left: 0.06rem;
          object-fit: contain;
          border: 0.03rem solid #5f5e5e;
          border-radius: 100%;
        }

        &::before {
          .size(100%);

          content: '';
          position: absolute;
          top: 0;
          left: 0;
          background: url('./images/timeline-decorate.png') no-repeat;
          background-size: 100% 100%;
          opacity: 0;
          transition: opacity 0.3s ease;
        }
      }

      &-title {
        width: 0.89rem;
        margin-top: 0.08rem;
        text-align: center;
        font-size: 0.28rem;
        font-weight: 700;
      }

      // 更多详情项的特殊样式
      &-more {
        white-space: nowrap;
        font-size: 0.24rem;
      }

      // NuxtLink 样式继承普通div样式
      a {
        color: inherit;
        text-decoration: none;

        &:hover {
          color: @landing-primary;
        }
      }
    }
  }
}

:global(.swiper-slide-active) {
  .timeline-thumbnail-image {
    img {
      border-color: #fff;
    }

    &::before {
      opacity: 1;
    }
  }
}

// fullpage.js 完全进入页面时的动画效果
:global(.fp-completely) {
  .about-nav {
    animation: fadeInDown 0.6s ease forwards;
  }

  .about-content {
    animation: fadeInUp 0.6s ease 0.5s forwards;
  }
}

// 淡入上移动画
@keyframes fadeInUp {
  from {
    transform: translateY(0.3rem);
  }
  to {
    transform: translateY(0);
  }
}

// 淡入下移动画
@keyframes fadeInDown {
  from {
    transform: translateY(-0.3rem);
  }
  to {
    transform: translateY(0);
  }
}

.btn-arrow {
  .size(0.81rem, 0.44rem);

  background: url('./images/btn-arrow.png') no-repeat;
  background-size: 100% 200%;

  &:hover {
    background-position: 0 100%;
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      background-position: 0 0;
    }
  }
}

// 横屏
:global(.landing-screen-landscape) {
  .about {
    padding: 1.64rem 2.9rem 0;

    &::before {
      top: 2.81rem;
    }

    &-mask::after {
      top: 0.85rem;
      right: 0.7rem;
    }

    &-nav {
      justify-content: flex-end;
      gap: 0.2rem;

      &-item {
        .size(1.71rem, 0.44rem);

        font-size: 0.28rem;

        // 最后一个导航项样式
        &:last-child {
          .size(0.81rem, 0.44rem);
        }
      }
    }

    &-section {
      &-title {
        width: 3rem;
        margin-top: 0.4rem;
        font-size: 0.36rem;
        padding-bottom: 0.1rem;

        span {
          font-size: 0.24rem;
        }
      }

      &-content {
        font-size: 0.24rem;

        p {
          margin-top: 0.48rem;

          &:first-child {
            margin-top: 0;
          }
        }
      }

      &-intro {
        // max-height: calc(100vh - 2.5rem - 1.64rem - 0.6rem - 0.44rem - 0.48rem);
        margin: 0.48rem 0 0;
        // overflow: auto;
      }
    }

    .timeline {
      &-gallery {
        width: 11.68rem;
        margin: -1.65rem auto 0;

        &-image {
          width: 11.68rem;
        }
      }
    }
  }
}

// 竖屏
:global(.landing-screen-portrait) {
  .about {
    padding: 3rem 0 0;

    &::before {
      top: 6.7rem;
    }

    &-mask::after {
      top: 1.3rem;
      right: 0;
    }

    &-nav {
      align-items: center;
      gap: 0.24rem;
      margin-left: 0.55rem;

      &-item {
        .size(1.81rem, 0.54rem);

        font-size: 0.34rem;

        // 最后一个导航项样式
        &:last-child {
          .size(0.81rem, 0.44rem);
        }
      }
    }

    &-section {
      &-title {
        width: 3.3rem;
        margin-top: 1rem;
        margin-left: 0.55rem;
        font-size: 0.42rem;
        padding-bottom: 0.15rem;

        span {
          font-size: 0.28rem;
        }
      }

      &-content {
        font-size: 0.3rem;

        p {
          margin-top: 0.68rem;

          &:first-child {
            margin-top: 0;
          }
        }
      }

      &-intro {
        // max-height: calc(100vh - 6.27rem - 3rem - 0.68rem - 1rem - 0.54rem);
        margin: 0.68rem 0.55rem 0;
        // overflow: auto;
      }
    }

    .timeline {
      &-gallery {
        width: 10.8rem;
        margin: 0 auto;

        &-image {
          width: 10.8rem;
        }

        &-title {
          margin-top: 0.2rem;
        }
      }

      &-thumbnail {
        margin-top: 0.5rem;
      }
    }
  }
}
</style>
